<template>
  <div class="resume">
    <div class="resume-editor" ref="editorFrom">
      <div>
        <!-- 基础信息 -->
        <div class="resumeSection">
          <div>
            <h2 class="resumeSection__title">基础信息</h2>
          </div>
          <div class="resumeSection__form">
            <el-form ref="form" :model="form" :rules="rules">
              <el-form-item label="姓名" prop="realName">
                <el-input
                  v-model="form.realName"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
              <el-form-item label="性别" prop="gender">
                <el-select
                  v-model="form.gender"
                  placeholder="请选择性别"
                  clearable
                  style="width: 100%"
                >
                  <el-option
                    v-for="(item, index) in sex"
                    :key="index"
                    :label="item"
                    :value="item"
                  />
                </el-select>
              </el-form-item>
              <el-form-item label="邮箱" prop="emailAddress">
                <el-input
                  v-model="form.emailAddress"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
              <el-form-item label="出生日期" prop="birthday">
                <el-date-picker
                  clearable
                  v-model="form.birthday"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="请选择出生年月"
                  style="width: 100%"
                >
                </el-date-picker>
              </el-form-item>
              <el-form-item label="学历" prop="educationLevel">
                <el-select
                  v-model="form.educationLevel"
                  placeholder="请选择学历"
                  clearable
                  style="width: 100%"
                >
                  <el-option
                    v-for="(item, index) in education"
                    :key="index"
                    :label="item"
                    :value="item"
                  />
                </el-select>
              </el-form-item>
              <el-form-item label="毕业时间" prop="graduteTime">
                <el-date-picker
                  clearable
                  v-model="form.graduteTime"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="请选择毕业时间"
                  style="width: 100%"
                >
                </el-date-picker>
              </el-form-item>
              <el-form-item label="工作年限" prop="workingTime">
                <el-select
                  v-model="form.workingTime"
                  placeholder="请选择学历"
                  clearable
                  style="width: 100%"
                >
                  <el-option
                    v-for="(item, index) in termArray"
                    :key="index"
                    :label="item"
                    :value="item"
                  />
                </el-select>
              </el-form-item>
              <el-form-item label="现居住地" prop="currentResidence">
                <el-cascader
                  style="width: 100%"
                  filterable
                  clearable
                  :options="options"
                  v-model="selectedOptions"
                  @change="addressChoose"
                ></el-cascader>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
    </div>
    <div ref="footerAction" class="resumeEditor-footerAction">
      <el-button round @click="$router.push('/resume')">取消</el-button>
      <el-button size="medium" @click="submit" type="primary">保存</el-button>
    </div>
  </div>
</template>

<script>
import { personalInfo, personalInfoCommit } from "@/api/index";
import {
  pcaTextArr // 省市区三级联动数据，纯汉字
} from "element-china-area-data";
import { Debounce } from "@/helper/utilities.js";
export default {
  name: "resume-basic",
  data() {
    return {
      sex: ["男", "女"],
      education: [
        "博士",
        "硕士",
        "本科",
        "大专",
        "中专",
        "高中",
        "初中",
        "其他"
      ],
      termArray: [
        "无工作经验",
        "1年以下工作经验",
        "1年-3年工作经验",
        "3年-5年工作经验",
        "5年-10年工作经验",
        "10年以上工作经验"
      ],
      options: pcaTextArr, // 省市区三级联数据，纯汉字
      selectedOptions: [],
      form: {
        realName: undefined,
        gender: undefined,
        emailAddress: undefined,
        birthday: undefined,
        educationLevel: undefined,
        graduteTime: undefined,
        workingTime: undefined,
        currentResidence: undefined
      },
      rules: {
        realName: [
          { required: true, message: "姓名不能为空", trigger: "blur" }
        ],
        gender: [{ required: true, message: "性别不能为空", trigger: "blur" }],
        emailAddress: [
          { required: true, message: "邮箱不能为空", trigger: "blur" },
          {
            pattern: /^([0-9A-Za-z\-_\.]+)@([0-9a-z]+\.[a-z]{2,3}(\.[a-z]{2})?)$/g,
            message: "请输入正确的邮箱",
            trigger: "blur"
          }
        ],
        birthday: [
          { required: true, message: "出生日期不能为空", trigger: "blur" }
        ],
        educationLevel: [
          { required: true, message: "学历不能为空", trigger: "blur" }
        ],
        graduteTime: [
          { required: true, message: "毕业时间不能为空", trigger: "blur" }
        ],
        workingTime: [
          { required: true, message: "工作年限不能为空", trigger: "blur" }
        ],
        currentResidence: [
          { required: true, message: "现居住地不能为空", trigger: "change" }
        ]
      }
    };
  },
  created() {
    this.getPersonalInfo();
  },
  methods: {
    getPersonalInfo() {
      personalInfo()
        .then(res => {
          if (res.code == 200) {
            if (res.data.reMiniProgramPerson) {
              this.form = res.data.reMiniProgramPerson;
              this.selectedOptions = res.data.reMiniProgramPerson.currentResidence.split(
                "-"
              );
            }
          }
        })
        .catch(err => {});
    },

    addressChoose(value) {
      if (value.length > 0) {
        this.form.currentResidence = value[0] + "-" + value[1] + "-" + value[2];
        this.selectedOptions = value;
      } else {
        this.form.currentResidence = "";
      }
    },

    submit: Debounce(function() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          personalInfoCommit(this.form)
            .then(res => {
              if (res.code == 200) {
                this.$router.go(-1);
                this.$message({
                  showClose: true,
                  message: "保存成功",
                  type: "success"
                });
              } else {
                this.$message({
                  showClose: true,
                  message: res.msg,
                  type: "warning"
                });
              }
            })
            .catch(err => {});
        }
      });
    }, 1000)
  }
};
</script>

<style lang="less" scoped>
.resume {
  margin-bottom: 30px;
}
.resume-editor {
  width: 900px;
  margin: auto;
  padding: 30px 0;
}
.resumeEditor-footerAction {
  width: 900px;
  margin: auto;
  z-index: 33;
  text-align: right;
  &-fix {
    width: 100%;
    background: #fff;
    position: fixed;
    bottom: 0;
    left: 0;

    box-shadow: 0 -2px 10px #eee;
  }
}
.resumeSection {
  padding: 50px 0;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid @border-base-color;

  &__title {
    margin-right: 200px;

    padding-bottom: 3px;
    border-bottom: 2px solid @main-color;
  }
  &__form {
    width: 600px;
  }
}
</style>
